import TYPES from '@/modules/shared/types';

// Domain
import { FinancialInstitutionRepository } from '../../domain/repository';
import { FinancialInstitutionEntity } from '../../domain/entities/financial-institution-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class FinancialInstitutionHttpRepository implements FinancialInstitutionRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/financial-institutions/search?codcondcobro=0002`;

  execute(): Promise<Array<FinancialInstitutionEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
